import styled from '@emotion/styled';
import { Flex } from 'lib/components/Flex';

export const FlexGray = styled(Flex)`
    padding: 8px;
    background: ${(p) => p.theme.color.grayDark2};
`;

FlexGray.displayName = 'FlexGray';
